import type { SVGProps } from 'react'
const SvgSyDiscovery = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="m14.729 7.555-5.09 1.591a.75.75 0 0 0-.493.493l-1.591 5.09a.75.75 0 0 0 .94.939l5.089-1.594a.75.75 0 0 0 .49-.49l1.594-5.09a.75.75 0 0 0-.94-.94m-.92 1.86-1.047 3.347-3.348 1.047 1.047-3.348z"
				clipRule="evenodd"
				opacity={0.4}
			/>
			<path d="M11.611 1.25C5.898 1.25 1.25 5.898 1.25 11.611s4.648 10.362 10.361 10.362 10.362-4.648 10.362-10.362c0-5.713-4.648-10.361-10.362-10.361m0 1.5a8.85 8.85 0 0 1 8.862 8.861 8.85 8.85 0 0 1-8.862 8.862A8.85 8.85 0 0 1 2.75 11.61a8.85 8.85 0 0 1 8.861-8.861" />
		</g>
	</svg>
)
export default SvgSyDiscovery
